import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core'
import { CompanyServiceProvider } from 'src/app/models/CompanyServiceProvider'
import { NotificationService } from 'src/app/services/notification.service'

@Component({
	selector: 'select-company-provider',
	templateUrl: './select-company-provider.component.html'
})
export class SelectCompanyProvider implements OnInit, OnDestroy {

		constructor(
				public notificationService: NotificationService
		) { }

		@Input() public allCompanyProviders: Array<CompanyServiceProvider> = []
		@Output() public cancelSelectCompanyProvider: EventEmitter<void> = new EventEmitter()
		@Output() public selectCompanyProvider: EventEmitter<CompanyServiceProvider> = new EventEmitter()

		public ngOnInit(): void {
				document.body.style.overflow = 'hidden'
		}

		public select(companyProvider: CompanyServiceProvider) {
				this.selectCompanyProvider.emit(companyProvider)
		}

		public cancel() {
				this.cancelSelectCompanyProvider.emit()
		}

		public ngOnDestroy(): void {
		document.body.style.overflow = 'auto'
		}
}
